<script lang="ts" setup>
import Dialog from 'primevue/dialog';
import { useViewport } from "@/composable/useViewport"
import { useTemplateRef } from 'vue';

const { isMobile } = useViewport()

const dia = useTemplateRef("dia")
const emit = defineEmits<{
  (e: 'show'): void
}>()

const onShow = () => {
  emit('show')
}

defineExpose({
  getRef: () => dia
})
</script>

<template>
  <!-- :class="[isMobile ? '!w-screen !h-screen !max-w-none !max-h-none !top-0 !left-0 !translate-x-0 !translate-y-0 rounded-none' : '']" -->
  <Dialog :class="[isMobile ? 'p-dialog-maximized' : '']" ref="dia" @show="onShow" v-bind="$attrs" position="center"
    :keep-in-viewport="true" :draggable="!isMobile">
    <!-- <slot></slot> -->

    <template v-for="(_, name) in $slots" #[name]="slotData">
      <slot :name="name" v-bind="slotData || {}" />
    </template>

    <!-- <template #header>
      <slot name="header"></slot>
    </template>
<template #footer>
      <slot name="footer"></slot>
    </template> -->
  </Dialog>
</template>
